import React from "react";
import styled from "styled-components";

const ObjetoPdf = styled.object`
  width: 100%;
  height: 70vh;
`;

/* En el celular el visor incrustado no sirve para leer el documento: Chrome de Android
   no muestra PDF dentro de <object> (queda en blanco) y Safari de iPhone muestra solo la
   primera página. Ahí se ofrece abrirlo en el visor del teléfono. */
const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
const ANDROID = /Android/i.test(ua);
const TACTIL =
  typeof window !== "undefined" && window.matchMedia && window.matchMedia("(hover: none) and (pointer: coarse)").matches;

export const StyledObject = ({ data, children, style, ...rest }) => {
  if (!TACTIL || !data) {
    return (
      <ObjetoPdf data={data} style={style} {...rest}>
        {children}
      </ObjetoPdf>
    );
  }
  return (
    <div className="gd-pdf-movil">
      <a className="gd-pdf-movil__abrir" href={data} target="_blank" rel="noopener noreferrer">
        Ver el documento completo
      </a>
      {!ANDROID && (
        <ObjetoPdf data={data} {...rest} style={{ ...style, height: "60vh", minHeight: 0 }}>
          {children}
        </ObjetoPdf>
      )}
    </div>
  );
};

export const StyledDivDialog = styled.div`
  padding: 10px;
`;
